import {
  ClipboardList,
  FileText,
  Package,
  PillBottle,
  RefreshCw,
  TestTube2,
} from "lucide-react";

const labTile = {
  id: "lab",
  label: "Laboratory",
  sub: "Orders & results",
  Icon: TestTube2,
  wrap: "bg-violet-100 text-violet-600",
};

const pharmacyTile = {
  id: "pharmacy",
  label: "Pharmacy",
  sub: "Dispensing",
  Icon: PillBottle,
  wrap: "bg-fuchsia-100 text-fuchsia-700",
};

function BridgeCard({ label, sub, Icon, wrap }) {
  return (
    <div className="flex min-h-[68px] min-w-0 flex-1 flex-col justify-between rounded-lg border border-slate-200/80 bg-gradient-to-br from-white via-slate-50/60 to-slate-100/70 px-1.5 py-2 shadow-sm sm:min-h-[76px] sm:rounded-xl sm:px-2 sm:py-2.5 md:min-h-[84px]">
      <div className="flex items-center gap-1.5 sm:gap-2">
        <div
          className={`flex size-8 shrink-0 items-center justify-center rounded-xl sm:size-9 md:size-10 ${wrap}`}
        >
          <Icon className="size-4 sm:size-[18px] md:size-5" strokeWidth={1.85} />
        </div>
        <div className="min-w-0">
          <p className="font-display text-[9px] font-bold leading-tight text-slate-900 sm:text-[10px] md:text-xs">
            {label}
          </p>
          <p className="mt-0.5 text-[7px] leading-snug text-slate-600 sm:text-[8px] md:text-[9px]">
            {sub}
          </p>
        </div>
      </div>
    </div>
  );
}

const workflow = [
  { id: "inv", label: "Inventory", Icon: Package, wrap: "bg-slate-100 text-slate-700" },
  { id: "ord", label: "Orders", Icon: ClipboardList, wrap: "bg-slate-100 text-slate-700" },
  { id: "rep", label: "Reports", Icon: FileText, wrap: "bg-slate-100 text-slate-700" },
];

export default function LabPharmacyPreviewMock() {
  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-2.5 rounded-[14px] bg-[#f4f6fa] p-2.5 sm:gap-3 sm:p-3 md:gap-3.5 md:p-3.5">
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="font-display text-[11px] font-bold leading-tight text-slate-900 sm:text-xs md:text-sm">
            Lab &amp; pharmacy
          </p>
          <p className="mt-0.5 text-[7px] font-medium text-slate-600 sm:text-[8px] md:text-[9px]">
            Connected workflows with live sync
          </p>
        </div>
        <span className="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-0.5 text-[7px] font-semibold text-emerald-800 ring-1 ring-emerald-200/90 sm:text-[8px] md:text-[9px]">
          <span className="size-1.5 rounded-full bg-emerald-500 sm:size-2" aria-hidden />
          In sync
        </span>
      </div>

      <div className="flex min-h-0 flex-1 items-stretch gap-1.5 sm:gap-2 md:gap-2.5">
        <BridgeCard {...labTile} />
        <div
          className="flex w-[2.25rem] shrink-0 flex-col items-center justify-center gap-0.5 rounded-lg border border-dashed border-violet-200/90 bg-violet-50/80 px-1 py-1 sm:w-[2.75rem] md:w-14"
          aria-hidden
        >
          <RefreshCw className="size-3.5 text-violet-600 sm:size-4 md:size-[18px]" strokeWidth={2} />
          <span className="text-center text-[6px] font-semibold uppercase tracking-wide text-violet-700 sm:text-[7px] md:text-[8px]">
            Live
          </span>
        </div>
        <BridgeCard {...pharmacyTile} />
      </div>

      <div className="grid grid-cols-3 gap-1 sm:gap-1.5 md:gap-2">
        {workflow.map(({ id, label, Icon, wrap }) => (
          <div
            key={id}
            className="flex flex-col items-center gap-1 rounded-lg border border-slate-200/80 bg-gradient-to-br from-white via-slate-50/60 to-slate-100/70 px-1 py-2 shadow-sm sm:rounded-xl sm:py-2.5"
          >
            <div
              className={`flex size-7 items-center justify-center rounded-xl sm:size-8 md:size-9 ${wrap}`}
            >
              <Icon className="size-3.5 sm:size-4 md:size-[18px]" strokeWidth={1.85} />
            </div>
            <span className="text-center text-[7px] font-semibold text-slate-800 sm:text-[8px] md:text-[9px]">
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
